import React from 'react';
import styled from 'react-emotion';
const QuantityWrapper = styled('div') `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: ${({ theme }) => theme.space[1]};
`;
const TrendInput = styled('input') `
  border: 0.5px solid #bfbdbd;
  height: 35px;
  font-size: 20px;
`;
export default TrendInput;
const QuantityInput = styled('input') `
  border: 1px solid #000000;
  width: 54px;
  height: 54px;
  font-size: 20px;
  text-align: center;
  padding: 0px;
`;
const QuantityLabel = styled('label') `
  font-size: 12px;
  text-align: center;
  letter-spacing: 0.05em;
  margin-bottom: 10px;
`;
export const Quantity = props => {
    return (React.createElement(QuantityWrapper, null,
        React.createElement(QuantityLabel, null, "Quantity"),
        React.createElement(QuantityInput, Object.assign({}, props))));
};
//# sourceMappingURL=Input.js.map